import {
  WebGLRenderTarget,
  Camera,
  RGBFormat,
  Mesh,
  Scene,
  RawShaderMaterial,
  Vector2,
} from 'three';

import * as THREE from 'three';
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer.js'
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass.js'


import { component } from 'bidello';
import renderer from '../renderer';
import settings from '../settings';
import triangle from '../utils/triangle';
import vertexShader from './postfx.vert';
import fragmentShader from './postfx.frag';
import camera from "../camera";
import scene from "../Scene";
class PostFX extends component() {
  init() {
    this.renderer = renderer;
    this.resolution = new Vector2();
    this.composer = new EffectComposer(renderer);
    this.composer.setSize(this.resolution.x, this.resolution.y);
    this.sceneRenderPass = new RenderPass(scene,camera, null, new THREE.Color().setHex( 0xffffff ), 0);
    this.composer.addPass(this.sceneRenderPass);
    //this.sceneRenderPass.renderToScreen = true;
    this.sceneRenderPass.clear = false;
    const defines = {};
    settings.fxaa && (defines.FXAA = true);
  }

  onResize() {
    //this.target.setSize(this.resolution.x, this.resolution.y);
    this.composer.setSize(this.resolution.x, this.resolution.y);
  }

  render(scene, camera) {

    //this.renderer.setRenderTarget(this.target);

    this.composer.render(0.1)

    //this.renderer.setRenderTarget(this.target);

    //this.renderer.setRenderTarget(null);
    //
    this.renderer.render(scene, camera);
  }
}

export default new PostFX();